/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable complexity */
import React, { useCallback, useMemo } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { ReactComponent as SortAsc } from 'src/assets/icons/sortAscending.svg';
import { ReactComponent as SortDesc } from 'src/assets/icons/sortDescending.svg';
import { ReactComponent as SortNeutral } from 'src/assets/icons/sortNeutral.svg';
import { flexRender } from '@tanstack/react-table';
import styles from './index.module.scss';

function Header({
  table,
  pinnedColumn,
  columnConfiguratorEnabled = true,
}: {
  table: any;
  pinnedColumn?: string;
  columnConfiguratorEnabled?: boolean;
}) {
  const sortIcon = useCallback((direction, canSort) => {
    if (direction === 'asc') {
      return <SortAsc />;
    }
    if (direction === 'desc') {
      return <SortDesc />;
    }
    if (canSort) {
      return <SortNeutral />;
    }
    return null;
  }, []);
  const columnVisibilityState = table.getState()?.columnVisibility;
  const columnOrderState = table.getState()?.columnOrder;
  const columns = table.getAllLeafColumns();
  const headerGroups = useMemo(
    () =>
      table
        .getHeaderGroups()
        .map((headerGroup) =>
          (headerGroup?.headers || []).filter(
            (header) => !header.isPlaceholder && header.column.getIsVisible(),
          ),
        ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [table, columnVisibilityState, columnOrderState, columns],
  );

  const getColumnStyles = (idx, column, total) => {
    const isFixed = column.id === 'select';

    let genericStyles: any = {
      width: isFixed ? 44 : column.getSize(),
      minWidth: isFixed ? 44 : column.getSize(),
      maxWidth: isFixed ? 44 : undefined,
    };

    if (idx === 0 && pinnedColumn === 'left') {
      return {
        ...genericStyles,
        left: `${column.getAfter('left')}px`,
        zIndex: 3,
        boxShadow:
          'var(--dimensions-none) var(--dimensions-none) 1px var(--dimensions-none) var(--color-alpha-14), var(--dimensions-100) var(--dimensions-none) var(--dimensions-150) var(--dimensions-none) var(--color-alpha-14)',
        position: 'sticky',
      };
    }

    if (idx === total - 1 && pinnedColumn === 'right') {
      genericStyles = {
        ...genericStyles,
        right: `${column.getAfter('right')}px`,
        zIndex: 3,
        boxShadow:
          'var(--dimensions-none) var(--dimensions-none) 1px var(--dimensions-none) var(--color-alpha-14), var(--dimensions-100) var(--dimensions-none) var(--dimensions-150) var(--dimensions-none) var(--color-alpha-14)',
        position: 'sticky',
      };
    }

    if (idx === total - 1) {
      genericStyles = {
        ...genericStyles,
        paddingRight: columnConfiguratorEnabled ? '45px' : undefined,
      };
    }
    return genericStyles;
  };

  return (
    <thead>
      {headerGroups.map((headerGroup, headerGroupIdx) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={headerGroupIdx} className={styles.tableWrapperV2__header}>
          {headerGroup.map((header, idx) => (
            <th
              key={header.id}
              colSpan={header.colSpan}
              style={getColumnStyles(idx, header.column, headerGroup.length)}
              data-test-id={`${header.column.id}-header`}
            >
              <div
                className={styles.tableWrapperV2__header__cell}
                onClick={header.column.getToggleSortingHandler()}
              >
                <Text semiBold>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                </Text>
                {sortIcon(
                  header.column.getIsSorted(),
                  header.column.getCanSort(),
                )}
              </div>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
}

export default Header;
